import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  buttonIcon: {
    height: '20px',
    width: '20px'
  },
  menuPaper: {
    width: '150px'
  },
  menuItem: {
    fontSize: '16px'
  },
  divider: {
    margin: '8px 0'
  },
  deleteMenuItem: {
    color: capitalDesignTokens.foundations.colors.ruby800
  }
});
